module.exports = __webpack_public_path__ + "media/images/countryrect/tj-ca2d59b65d25b666b592e363968e962c.svg";